//
// helpers/functional.js - FP helpers
//


// curry
// --------------------------

function curry(f, ...args_outer) {
  return function(...args) {
    return f.apply(this, args_outer.concat(args));
  };
}


// reverse_curry - curry from the right-hand end of the parameter list
// --------------------------

function reverse_curry(f, ...args_outer) {
  return function(...args) {
    return f.apply(this, args.concat(args_outer.reverse()));
  };
}


// chain - returns a function to call N funcs in order with the same params
// --------------------------

function chain(...funcs) {
  return function chained(...args) {
    funcs.forEach(function(f) { f.apply(null, args); });
  };
}


export {
  curry,
  reverse_curry,
  chain,
};
